var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import { Button } from '../../button/src';
import { Icon } from '../../icon/src';
export var Alert = AwsUi.__addComponent('awsui-alert', {
    releaseStatus: 'stable',
    events: {
        // Fired when the user clicks on the close icon that is displayed
        // when the `dismissible` property is set to `true`.
        dismiss: {
            cancelable: true
        },
        // Fired when the alert is shown, namely when the `visible` property changes from false to
        // true.
        show: {
            cancelable: false
        },
        // Fired when the alert is hidden, namely when the `visible` property changes from true to
        // false.  It is typically fired after the `awsui:dismiss`event.
        hide: {
            cancelable: false
        },
        // Fired when the user clicks on the action button.
        buttonClick: {
            cancelable: false
        }
    },
    properties: {
        // Indicates the type of the message to be displayed.
        type: {
            nullable: false,
            valid: ['success', 'error', 'warning', 'info'],
            defaultValue: 'info'
        },
        // Determines whether the alert is displayed to the user or not.
        visible: {
            type: 'boolean',
            defaultValue: true,
            onChange: function (oldVal, newVal) {
                var hiddenAttribute = 'awsui-alert-hidden';
                if (!newVal) {
                    this.node.setAttribute(hiddenAttribute, hiddenAttribute);
                    this.__fireEvent('hide');
                }
                else {
                    this.node.removeAttribute(hiddenAttribute);
                    this.__fireEvent('show');
                }
            }
        },
        // If true, the component will include a close button in the UI.
        // Clicking on this button will fire the `awsui:dismiss` event and will set the `visible` property to false.
        dismissible: {
            type: 'boolean'
        },
        // Adds an aria-label to the dismiss button
        dismissLabel: {
            type: 'string'
        }
    },
    regions: {
        // Heading text.
        header: {},
        // Primary text displayed in the element.
        content: {
            isDefault: true
        },
        // Displays an action button next to the message area when set.
        // An `awsui:buttonClick` event will be triggered when the user clicks on it.
        buttonText: {}
    },
    render: function (m, h) {
        var _this = this;
        var dismiss = function () {
            if (!_this.dismissible) {
                return;
            }
            var click = function () {
                _this.__fireEvent('dismiss', null, {
                    onNotCanceled: function () {
                        _this.visible = false;
                    }
                });
            };
            var cb = new LegacyClassBuilder(_this)
                .addComponentClass('dismiss')
                .addComponentClass('dismiss-with-button', !!_this.buttonText);
            return (AwsUi.__createElement("div", { className: cb.toClassName() },
                AwsUi.__createElement(Button, { variant: "icon", icon: "close", formAction: "none", label: _this.dismissLabel, click: click })));
        };
        var header = function () {
            if (_this.getRegion('header')) {
                return h.region('header', 'div', { className: 'awsui-alert-header' });
            }
        };
        var button = function () {
            if (!_this.buttonText) {
                return;
            }
            var trigger = function () { return _this.__fireEvent('buttonClick'); };
            return AwsUi.__createElement(Button, { text: _this.buttonText, className: "awsui-alert-action-button", click: trigger, formAction: "none" });
        };
        var iconByType = {
            success: { name: 'status-positive' },
            warning: { name: 'status-warning' },
            info: { name: 'status-info' },
            error: { name: 'status-negative' }
        };
        var cb = new LegacyClassBuilder(this).addClass('awsui-alert').addPropertyValueClass('type');
        var icon = function () {
            var multiline = _this.getRegion('header') && _this.getRegion('content');
            var attributes = {
                name: iconByType[_this.type].name,
                size: multiline ? 'big' : 'normal'
            };
            return (AwsUi.__createElement("div", { className: "awsui-alert-icon" },
                AwsUi.__createElement(Icon, __assign({}, attributes))));
        };
        return (AwsUi.__createElement("div", { className: cb.toClassName(), "aria-hidden": !this.visible },
            icon(),
            AwsUi.__createElement("div", { className: "awsui-alert-body" },
                AwsUi.__createElement("div", { className: "awsui-alert-message" },
                    header(),
                    h.region('content')),
                button()),
            dismiss()));
    }
});
//# sourceMappingURL=index.js.map